import TOPMENUIMG from '../images/icon-topmenu-w.svg';
import LOGOTOP from '../images/sooki-logo.png';
import { Link } from 'react-router-dom';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useCookies } from 'react-cookie';
import { useNavigate } from "react-router-dom"
import {useEffect} from "react";
import {ApiRequest} from "../Consts/ApiRequest";

type LogoutInputs = {
  access_token: string;
  authority: number;
};

const Header = (props:any) => {
  const { register, handleSubmit, formState: { errors } } = useForm<LogoutInputs>();
  const navigate = useNavigate()
  const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);

    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

  const onSubmit: SubmitHandler<LogoutInputs> = async (data) => {
      const token = cookies.access_token || "";
      await ApiRequest.postLogout(token, (response: any) => {
          removeCookie('access_token', {path: '/'});
          removeCookie('authority', {path: '/'});
          navigate("/login");
      }, (error: any) => {
          errorCallback(error);
      });
  };

  useEffect(() => {
    if(!cookies.access_token) navigate("/login");
  }, [])

  const getTopPage = () => {
    if(cookies.authority == 2) return "/site_admin";
    if(cookies.authority > 2) return `/dashboard/${props.siteId}/${props.siteRecno}`;
    return "/topmenu";
  }
  const getTopPageLink = () => {
    let url = getTopPage();
    //alert(url);
    return url;
  }

  return (
    <header className="header" id="header">
      <div className="header-main">
        {cookies.authority == 1 ?
            <div className="header-topmenu">
              <Link to="/topmenu">
                <img src="https://www.sooki-cloud-portalsystem.jp/static/media/icon-topmenu-w.009b2b286bdaa260f21347de5795c2aa.svg" alt="SOOKI" />
              </Link>
            </div>:<></>
        }
        <div className="header-logo">
          <Link to={props.TopPage ?? getTopPageLink()}>
            <img src="https://www.sooki-cloud-portalsystem.jp/static/media/sooki-logo.7b93a1d920c631c633cc.png" alt="トップメニュー" />
          </Link>
        </div>
        <div className="header-name">ソーキクラウドポータルシステム</div>
      </div>
      <div className="header-sub">
        {
          props.siteName? <div className="header-genbaname">
          <span className="header-genbaname-label">現場</span>
            {props.siteName}
          </div>:<></>
        }
        {
          props.showMenu?<Link to={`/menu/${props.siteId}/${props.siteRecno}`}>
              <button className="btn btn-s btn-blue">メニュー</button>
          </Link>:<></>
        }
        <div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <button type="submit" className="btn btn-s btn-gray-line">
              ログアウト
            </button>
          </form>
        </div>
      </div>
    </header>
  );
};

export default Header;
